// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../../components/Utils/AppLogoImg';

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var dashboardCommonJS = require("../../js/dashboardCommon.js")

const AvailableApplicationsList = (functionParam) => {

  useEffect(() => {   
    initialConfigCommonJS.mostrarAplicacionesValidas(functionParam.selecteDeviceToConfigure,"listadoAplicacionesBuscador")          
    initialConfigCommonJS.mostrarAplicacionesValidas("","listadoAppsDispositivosInteligentes")         
  });

  function seleccionarAplicacion(aplicacion){       
    
    var campoDispositivoActual = localStorage.getItem("deviceToConfigure")
    
    document.getElementById("divMensajeError").className = document.getElementById("divMensajeError").className.replaceAll(" hidden","") + " hidden"

    if(campoDispositivoActual !== null){ //Esto en un paso normal
        functionParam.setAppToRegister(aplicacion)
    }
    else{ //Estoy en el paso de dispositivos
        functionParam.setAppToConsult(aplicacion)    
    }
        
    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("formularioRegistroAplicacion","noUpdate")
  }

  return (    
    <>
    <header>
        <figure className="avatar size-m orange"><span id="spanIconVincular" className="material-icon">cable</span></figure>
        <h1 id="headerVincular" className="headline-03">...</h1>
    </header>
    <section className="brands">

        <fieldset id="buscadorAplicaciones">            
            <fieldset className="search automatic fill">
                <input type="search" id="textoBuscador" spellCheck="false" autoComplete="off" placeholder="Buscar aplicación..." onKeyUp={() => initialConfigCommonJS.filtrarAplicaciones()}/> 
                <span className="material-icon icon-wrapper" onClick={() => dashboardCommonJS.inicializarCajaBusqueda("textoBuscador","APLICACIONES_DISPONIBLES","Instaladores")}></span>
            </fieldset>
        </fieldset>

        <section className="brands-list">
            <ul id="listadoAplicacionesBuscador">
                <li id="EFERGY" searchvisibility="EFERGY">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("EFERGY")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="EFERGY"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("EFERGY")}</h1>
                    </div>              
                    </button>
                </li>
                <li id="EWELINK" searchvisibility="EWELINK">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("EWELINK")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="EWELINK"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("EWELINK")}</h1>
                    </div>
                    </button>
                </li>
                <li id="FUSIONSOLAR" searchvisibility="FUSIONSOLAR">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("FUSIONSOLAR")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="FUSIONSOLAR"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("FUSIONSOLAR")}</h1>
                    </div>
                    </button>
                </li>
                <li id="SHELLY" searchvisibility="SHELLY">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("SHELLY")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SHELLY"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("SHELLY")}</h1>
                    </div>
                    </button>
                </li>
                <li id="SMARTLIFE" searchvisibility="SMARTLIFE">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("SMARTLIFE")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SMARTLIFE"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("SMARTLIFE")}</h1>
                    </div>
                    </button>
                </li>
                <li id="TESLA" searchvisibility="TESLA">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("TESLA")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="TESLA"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("TESLA")}</h1>
                    </div>
                    </button>
                </li>            
                <li id="TPLINK" searchvisibility="TPLINK">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("TPLINK")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="TPLINK"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("TPLINK")}</h1>
                    </div>
                    </button>
                </li>
                <li id="TUYA" searchvisibility="TUYA">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("TUYA")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="TUYA"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("TUYA")}</h1>
                    </div>
                    </button>
                </li>
                <li id="VICTRON" searchvisibility="VICTRON">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("VICTRON")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="VICTRON"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("VICTRON")}</h1>
                    </div>
                    </button>
                </li>                                  
                <li id="TAPO" searchvisibility="TAPO">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("TAPO")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="TAPO"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("TAPO")}</h1>
                    </div>
                    </button>
                </li>                                  
                <li id="ARISTON" searchvisibility="ARISTON">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("ARISTON")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="ARISTON"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("ARISTON")}</h1>
                    </div>
                    </button>
                </li>  
                <li id="BRONPI" searchvisibility="BRONPI">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("BRONPI")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="BRONPI"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("BRONPI")}</h1>
                    </div>
                    </button>
                </li>  
                <li id="SOLARWEB" searchvisibility="SOLARWEB">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("SOLARWEB")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SOLARWEB"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("SOLARWEB")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="ECOFORESTCONTROL" searchvisibility="ECOFORESTCONTROL">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("ECOFORESTCONTROL")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="ECOFORESTCONTROL"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("ECOFORESTCONTROL")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="BROADLINK" searchvisibility="BROADLINK">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("BROADLINK")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="BROADLINK"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("BROADLINK")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="HOME_ASSISTANT" searchvisibility="HOME_ASSISTANT">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("HOME_ASSISTANT")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="HOME_ASSISTANT"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("HOME_ASSISTANT")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="KOSTAL" searchvisibility="KOSTAL">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("KOSTAL")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="KOSTAL"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("KOSTAL")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="KOSTAL_LOCAL" searchvisibility="KOSTAL_LOCAL">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("KOSTAL_LOCAL")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="KOSTAL_LOCAL"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("KOSTAL_LOCAL")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="IBERDROLA_SMART_MONITOR" searchvisibility="IBERDROLA_SMART_MONITOR">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("IBERDROLA_SMART_MONITOR")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="IBERDROLA_SMART_MONITOR"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("IBERDROLA_SMART_MONITOR")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="EDP_SOLAR" searchvisibility="EDP_SOLAR">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("EDP_SOLAR")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="EDP_SOLAR"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("EDP_SOLAR")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="ENERGEEKS_30" searchvisibility="ENERGEEKS_30">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("ENERGEEKS_30")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="ENERGEEKS_30"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("ENERGEEKS_30")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="SOLARMAN" searchvisibility="SOLARMAN">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("SOLARMAN")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SOLARMAN"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("SOLARMAN")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="ESAJ_HOME" searchvisibility="ESAJ_HOME">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("ESAJ_HOME")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="ESAJ_HOME"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("ESAJ_HOME")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="IAQUALINK" searchvisibility="IAQUALINK">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("IAQUALINK")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="IAQUALINK"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("IAQUALINK")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="MELCLOUD" searchvisibility="MELCLOUD">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("MELCLOUD")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="MELCLOUD"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("MELCLOUD")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="COMFORT_CLOUD" searchvisibility="COMFORT_CLOUD">
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("COMFORT_CLOUD")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="COMFORT_CLOUD"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("COMFORT_CLOUD")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="MEROSS" searchvisibility="MEROSS" className=" hidden"> 
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("MEROSS")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="MEROSS"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("MEROSS")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="ONECTA_DAIKIN" searchvisibility="ONECTA_DAIKIN" className=" hidden"> 
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("ONECTA_DAIKIN")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="ONECTA_DAIKIN"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("ONECTA_DAIKIN")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="GOVEE" searchvisibility="GOVEE" className=" hidden"> 
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("GOVEE")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="GOVEE"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("GOVEE")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="XIAOMI" searchvisibility="XIAOMI" className=" hidden"> 
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("XIAOMI")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="XIAOMI"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("XIAOMI")}</h1>
                    </div>
                    </button>
                </li> 
                <li id="SMARTTHINGS" searchvisibility="SMARTTHINGS" className=" hidden"> 
                    <button className="selector icon-wrapper" onClick={() => seleccionarAplicacion("SMARTTHINGS")}>
                    <figure className="avatar size-m"><AppLogoImg aplicacion="SMARTTHINGS"/></figure>
                    <div className="content">
                        <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo("SMARTTHINGS")}</h1>
                    </div>
                    </button>
                </li> 
            </ul>

            <a className="message info left" href="https://fevergy.com/Contacto" target="_blank" rel="noopener noreferrer">
                <div className="horizontal">
                    <h1 className="title">¿No está tu aplicación?</h1>
                    <span className="material-icon">launch</span>
                </div>
                <p>Haz click aquí y dinos qué aplicación utilizas, estaremos encantados de añadirla</p>
            </a>

        </section>
    </section>
    </>
  )
}

export default AvailableApplicationsList